import './module.js';
import './controllers/moduleController.js';
import './directives/moduleDirectives.js';
import './services/moduleService.js';
